import React from 'react'
import t from '~t'

import DragItem from '~co/bookmarks/dnd/drag/item'
import { SuperLink, SafeHtml, SafeMarkdown } from '~ui';
import Cover from './cover'
import Tags from './tags'
import Highlights from './highlights'
import Reminder from './reminder'
import Info from './info'
import Actions from './actions'
import { PreloadPreviewLink } from '~routes/my/item/tab/preview'

export default function BookmarkItemView(props) {
    const { innerRef, isDragging } = props
    const { _id, link, title, excerpt, highlight, cover, domain, tags, note, highlights, reminder, view, access, spaceId } = props
    const { active, selected, selectModeEnabled, selectDisabled, important, broken, coverSize } = props
    const { onClick, onDoubleClick, onSelectClick, onContextMenu, onKeyUp } = props

    return (
        <DragItem 
            {...props}
            ghostClassName={'ui-bm-item-drag-ghost'}>{drag=>(
            <article 
                ref={innerRef}
                role='listitem'
                className={`
                    ${'ui-bm-item'}
                    ${active&&'ui-bm-item-active'}
                    ${selected&&'ui-bm-item-checked'}
                    ${important&&'ui-bm-item-important'}
                    ${broken&&'ui-bm-item-broken'}
                    ${isDragging&&'ui-bm-item-dragging'}
                    ui-bm-item-${view}
                    ${selectModeEnabled&&'ui-bm-item-select-mode'}
                `}
                data-id={_id}
                {...drag}>
                <Cover
                    cover={cover}
                    domain={domain}
                    link={link}
                    view={view}
                    coverSize={coverSize} />

                <div className={'ui-bm-about'}>
                    {/* Text */}
                    <SafeHtml className={'ui-bm-title'} html={highlight.title || title} />
                    
                    <div className={'ui-bm-description'}>
                        {note ? (
                            <SafeMarkdown className={'ui-bm-note'} markdown={highlight.note || note} />
                        ) : null}
                        {highlight.body || highlight.excerpt ? (
                            <SafeHtml className={'ui-bm-body'} html={highlight.body || highlight.excerpt} />
                        ) : (
                            excerpt ? (
                                <SafeHtml className={'ui-bm-excerpt'} html={excerpt} />
                            ) : null
                        )}
                        <Reminder reminder={reminder} />
                        <Highlights className={'ui-bm-highlights'} highlights={highlights} />
                        <Tags tags={tags} spaceId={spaceId} />
                    </div>

                    {/* Info */}
                    <Info 
                        {...props}
                        className={'ui-bm-info'} />
                </div>

                <Actions 
                    {...props}
                    className={'ui-bm-actions'} />

                {access && access.level >= 3 ? (
                    <label
                        className={`${'ui-bm-select'} ${selected ? 'ui-bm-item-active' : 'ui-bm-select-default'}`}
                        title={t.s('select')}>
                        <input type='checkbox' readOnly checked={selected} disabled={selectDisabled} onClick={onSelectClick} />
                    </label>
                ) : null}

                <SuperLink
                    href={link}
                    rel='noopener'

                    className={'ui-bm-permalink'}

                    active={active}
                    tabIndex='0'

                    onClick={onClick}
                    onDoubleClick={onDoubleClick}
                    onContextMenu={onContextMenu}
                    onKeyUp={onKeyUp}>
                    {title}
                </SuperLink>

                <PreloadPreviewLink item={props} />
            </article>
        )}</DragItem>
    )
}